<template>
  <div class="supply">
    <el-form ref="form" label-width="70px" :model="form" :rules="rules">
      <el-form-item label="题干" prop="question">
        <el-input
          v-model="form.question"
          type="textarea"
          :autosize="{ minRows: 1 }"
          resize="none"
          placeholder="请输入题干"
          :readonly="!isEdit"
        />
      </el-form-item>
      <el-form-item label="答案" prop="answerList">
        <div class="answers" v-for="(i, idx) in form.emptyCount" :key="idx">
          <span>第{{ idx + 1 }}空</span>
          <el-input
            v-model="form.answerList[idx]"
            type="textarea"
            :autosize="{ minRows: 1 }"
            resize="none"
            placeholder="请输入答案"
            class="option_input"
            :readonly="!isEdit"
          />
          <i class="el-icon-delete" @click="delItem(idx)" v-show="isEdit"></i>
        </div>
        <el-button
          v-show="isEdit"
          icon="el-icon-plus"
          @click="addItem"
          size="small"
          style="margin-top: 10px"
          >添加答案</el-button
        >
      </el-form-item>
      <el-form-item label="分值" prop="score" v-if="!noScore">
        <el-input-number
          v-model="form.score"
          size="small"
          :min="0"
          :controls="false"
        ></el-input-number>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "supply",
  props: {
    form: Object,
    noScore: Boolean,
    isEdit: Boolean,
  },
  data() {
    return {
      rules: {
        question: [
          { required: true, message: "题干不能为空", trigger: "blur" },
        ],
        answerList: {
          required: true,
          message: "答案不能为空",
          trigger: "blur",
        },
        score: [{ required: true, message: "分值不能为空", trigger: "change" }],
      },
    };
  },
  methods: {
    addItem() {
      this.form.emptyCount++;
    },
    delItem(idx) {
      if (this.form.emptyCount <= 1) {
        this.$message({
          message: "至少需要1个答案",
          type: "warning",
        });
        return;
      }
      this.form.emptyCount--;
      this.form.answerList.splice(idx, 1);
    },
    checkOption() {
      if (
        this.form.answerList.length == 0 ||
        this.form.answerList.length != this.form.emptyCount ||
        this.form.answerList.some((item) => {
          return item == "";
        })
      ) {
        this.$message.error("请填写答案");
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scope>
.answers {
  margin-bottom: 10px;
}
.option_input {
  margin-left: 10px;
  width: 85%;
  vertical-align: middle;
}

.el-icon-delete {
  margin-left: 10px;
  font-size: 20px;
  color: #f56c6c;
  vertical-align: middle;
  cursor: pointer;
}
</style>